// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__2kdCJ","text":"LimitedAccessBanner_text__8u_js","button":"LimitedAccessBanner_button__2y5Il"};